"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
require("core-js/modules/esnext.promise.all-settled.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Account = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var depd_1 = __importDefault(require("depd"));
var transaction_1 = require("./transaction");
var providers_1 = require("./providers");
var borsh_1 = require("borsh");
var key_pair_1 = require("./utils/key_pair");
var errors_1 = require("./utils/errors");
var rpc_errors_1 = require("./utils/rpc_errors");
var constants_1 = require("./constants");
var exponential_backoff_1 = __importDefault(require("./utils/exponential-backoff"));
// Default number of retries with different nonce before giving up on a transaction.
var TX_NONCE_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
var TX_NONCE_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
var TX_NONCE_RETRY_WAIT_BACKOFF = 1.5;
function parseJsonFromRawResponse(response) {
  return JSON.parse(Buffer.from(response).toString());
}
function bytesJsonStringify(input) {
  return Buffer.from(JSON.stringify(input));
}
/**
 * This class provides common account related RPC calls including signing transactions with a {@link utils/key_pair!KeyPair}.
 *
 * @hint Use {@link walletAccount!WalletConnection} in the browser to redirect to [NEAR Wallet](https://wallet.near.org/) for Account/key management using the {@link key_stores/browser_local_storage_key_store!BrowserLocalStorageKeyStore}.
 * @see [https://docs.near.org/docs/develop/front-end/naj-quick-reference#account](https://docs.near.org/tools/near-api-js/quick-reference#account)
 * @see [Account Spec](https://nomicon.io/DataStructures/Account.html)
 */
var Account = /*#__PURE__*/function () {
  function Account(connection, accountId) {
    _classCallCheck(this, Account);
    /** @hidden */
    this.accessKeyByPublicKeyCache = {};
    this.connection = connection;
    this.accountId = accountId;
  }
  /**
   * Returns basic NEAR account information via the `view_account` RPC query method
   * @see [https://docs.near.org/api/rpc/contracts#view-account](https://docs.near.org/api/rpc/contracts#view-account)
   */
  _createClass(Account, [{
    key: "state",
    value: function state() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.connection.provider.query({
                request_type: 'view_account',
                account_id: this.accountId,
                finality: 'optimistic'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /** @hidden */
  }, {
    key: "printLogsAndFailures",
    value: function printLogsAndFailures(contractId, results) {
      if (!process.env['NEAR_NO_LOGS']) {
        var _iterator = _createForOfIteratorHelper(results),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var result = _step.value;
            console.log("Receipt".concat(result.receiptIds.length > 1 ? 's' : '', ": ").concat(result.receiptIds.join(', ')));
            this.printLogs(contractId, result.logs, '\t');
            if (result.failure) {
              console.warn("\tFailure [".concat(contractId, "]: ").concat(result.failure));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    /** @hidden */
  }, {
    key: "printLogs",
    value: function printLogs(contractId, logs) {
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (!process.env['NEAR_NO_LOGS']) {
        var _iterator2 = _createForOfIteratorHelper(logs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var log = _step2.value;
            console.log("".concat(prefix, "Log [").concat(contractId, "]: ").concat(log));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    /**
     * Create a signed transaction which can be broadcast to the network
     * @param receiverId NEAR account receiving the transaction
     * @param actions list of actions to perform as part of the transaction
     * @see {@link providers/json-rpc-provider!JsonRpcProvider#sendTransaction | JsonRpcProvider.sendTransaction}
     */
  }, {
    key: "signTransaction",
    value: function signTransaction(receiverId, actions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var accessKeyInfo, accessKey, block, blockHash, nonce;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.findAccessKey(receiverId, actions);
            case 2:
              accessKeyInfo = _context2.sent;
              if (accessKeyInfo) {
                _context2.next = 5;
                break;
              }
              throw new providers_1.TypedError("Can not sign transactions for account ".concat(this.accountId, " on network ").concat(this.connection.networkId, ", no matching key pair exists for this account"), 'KeyNotFound');
            case 5:
              accessKey = accessKeyInfo.accessKey;
              _context2.next = 8;
              return this.connection.provider.block({
                finality: 'final'
              });
            case 8:
              block = _context2.sent;
              blockHash = block.header.hash;
              nonce = accessKey.nonce.add(new bn_js_1.default(1));
              _context2.next = 13;
              return (0, transaction_1.signTransaction)(receiverId, nonce, actions, (0, borsh_1.baseDecode)(blockHash), this.connection.signer, this.accountId, this.connection.networkId);
            case 13:
              return _context2.abrupt("return", _context2.sent);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Sign a transaction to preform a list of actions and broadcast it using the RPC API.
     * @see {@link providers/json-rpc-provider!JsonRpcProvider#sendTransaction | JsonRpcProvider.sendTransaction}
     */
  }, {
    key: "signAndSendTransaction",
    value: function signAndSendTransaction(_ref) {
      var receiverId = _ref.receiverId,
        actions = _ref.actions,
        returnError = _ref.returnError;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;
        var txHash, signedTx, result, flatLogs;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, exponential_backoff_1.default)(TX_NONCE_RETRY_WAIT, TX_NONCE_RETRY_NUMBER, TX_NONCE_RETRY_WAIT_BACKOFF, function () {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var _yield$this$signTrans, _yield$this$signTrans2, publicKey;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return this.signTransaction(receiverId, actions);
                      case 2:
                        _yield$this$signTrans = _context3.sent;
                        _yield$this$signTrans2 = _slicedToArray(_yield$this$signTrans, 2);
                        txHash = _yield$this$signTrans2[0];
                        signedTx = _yield$this$signTrans2[1];
                        publicKey = signedTx.transaction.publicKey;
                        _context3.prev = 7;
                        _context3.next = 10;
                        return this.connection.provider.sendTransaction(signedTx);
                      case 10:
                        return _context3.abrupt("return", _context3.sent);
                      case 13:
                        _context3.prev = 13;
                        _context3.t0 = _context3["catch"](7);
                        if (!(_context3.t0.type === 'InvalidNonce')) {
                          _context3.next = 19;
                          break;
                        }
                        (0, errors_1.logWarning)("Retrying transaction ".concat(receiverId, ":").concat((0, borsh_1.baseEncode)(txHash), " with new nonce."));
                        delete this.accessKeyByPublicKeyCache[publicKey.toString()];
                        return _context3.abrupt("return", null);
                      case 19:
                        if (!(_context3.t0.type === 'Expired')) {
                          _context3.next = 22;
                          break;
                        }
                        (0, errors_1.logWarning)("Retrying transaction ".concat(receiverId, ":").concat((0, borsh_1.baseEncode)(txHash), " due to expired block hash"));
                        return _context3.abrupt("return", null);
                      case 22:
                        _context3.t0.context = new providers_1.ErrorContext((0, borsh_1.baseEncode)(txHash));
                        throw _context3.t0;
                      case 24:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, this, [[7, 13]]);
                }));
              });
            case 2:
              result = _context4.sent;
              if (result) {
                _context4.next = 5;
                break;
              }
              throw new providers_1.TypedError('nonce retries exceeded for transaction. This usually means there are too many parallel requests with the same access key.', 'RetriesExceeded');
            case 5:
              flatLogs = [result.transaction_outcome].concat(_toConsumableArray(result.receipts_outcome)).reduce(function (acc, it) {
                if (it.outcome.logs.length || typeof it.outcome.status === 'object' && typeof it.outcome.status.Failure === 'object') {
                  return acc.concat({
                    'receiptIds': it.outcome.receipt_ids,
                    'logs': it.outcome.logs,
                    'failure': typeof it.outcome.status.Failure != 'undefined' ? (0, rpc_errors_1.parseRpcError)(it.outcome.status.Failure) : null
                  });
                } else return acc;
              }, []);
              this.printLogsAndFailures(signedTx.transaction.receiverId, flatLogs);
              // Should be falsy if result.status.Failure is null
              if (!(!returnError && typeof result.status === 'object' && typeof result.status.Failure === 'object' && result.status.Failure !== null)) {
                _context4.next = 13;
                break;
              }
              if (!(result.status.Failure.error_message && result.status.Failure.error_type)) {
                _context4.next = 12;
                break;
              }
              throw new providers_1.TypedError("Transaction ".concat(result.transaction_outcome.id, " failed. ").concat(result.status.Failure.error_message), result.status.Failure.error_type);
            case 12:
              throw (0, rpc_errors_1.parseResultError)(result);
            case 13:
              return _context4.abrupt("return", result);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * Finds the {@link providers/provider!AccessKeyView} associated with the accounts {@link utils/key_pair!PublicKey} stored in the {@link key_stores/keystore!KeyStore}.
     *
     * @todo Find matching access key based on transaction (i.e. receiverId and actions)
     *
     * @param receiverId currently unused (see todo)
     * @param actions currently unused (see todo)
     * @returns `{ publicKey PublicKey; accessKey: AccessKeyView }`
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "findAccessKey",
    value: function findAccessKey(receiverId, actions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var publicKey, cachedAccessKey, rawAccessKey, accessKey;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
            case 2:
              publicKey = _context5.sent;
              if (publicKey) {
                _context5.next = 5;
                break;
              }
              throw new providers_1.TypedError("no matching key pair found in ".concat(this.connection.signer), 'PublicKeyNotFound');
            case 5:
              cachedAccessKey = this.accessKeyByPublicKeyCache[publicKey.toString()];
              if (!(cachedAccessKey !== undefined)) {
                _context5.next = 8;
                break;
              }
              return _context5.abrupt("return", {
                publicKey: publicKey,
                accessKey: cachedAccessKey
              });
            case 8:
              _context5.prev = 8;
              _context5.next = 11;
              return this.connection.provider.query({
                request_type: 'view_access_key',
                account_id: this.accountId,
                public_key: publicKey.toString(),
                finality: 'optimistic'
              });
            case 11:
              rawAccessKey = _context5.sent;
              // store nonce as BN to preserve precision on big number
              accessKey = Object.assign(Object.assign({}, rawAccessKey), {
                nonce: new bn_js_1.default(rawAccessKey.nonce)
              }); // this function can be called multiple times and retrieve the same access key
              // this checks to see if the access key was already retrieved and cached while
              // the above network call was in flight. To keep nonce values in line, we return
              // the cached access key.
              if (!this.accessKeyByPublicKeyCache[publicKey.toString()]) {
                _context5.next = 15;
                break;
              }
              return _context5.abrupt("return", {
                publicKey: publicKey,
                accessKey: this.accessKeyByPublicKeyCache[publicKey.toString()]
              });
            case 15:
              this.accessKeyByPublicKeyCache[publicKey.toString()] = accessKey;
              return _context5.abrupt("return", {
                publicKey: publicKey,
                accessKey: accessKey
              });
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](8);
              if (!(_context5.t0.type == 'AccessKeyDoesNotExist')) {
                _context5.next = 23;
                break;
              }
              return _context5.abrupt("return", null);
            case 23:
              throw _context5.t0;
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[8, 19]]);
      }));
    }
    /**
     * Create a new account and deploy a contract to it
     *
     * @param contractId NEAR account where the contract is deployed
     * @param publicKey The public key to add to the created contract account
     * @param data The compiled contract code
     * @param amount of NEAR to transfer to the created contract account. Transfer enough to pay for storage https://docs.near.org/docs/concepts/storage-staking
     */
  }, {
    key: "createAndDeployContract",
    value: function createAndDeployContract(contractId, publicKey, data, amount) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var accessKey, contractAccount;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              accessKey = (0, transaction_1.fullAccessKey)();
              _context6.next = 3;
              return this.signAndSendTransaction({
                receiverId: contractId,
                actions: [(0, transaction_1.createAccount)(), (0, transaction_1.transfer)(amount), (0, transaction_1.addKey)(key_pair_1.PublicKey.from(publicKey), accessKey), (0, transaction_1.deployContract)(data)]
              });
            case 3:
              contractAccount = new Account(this.connection, contractId);
              return _context6.abrupt("return", contractAccount);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
    /**
     * @param receiverId NEAR account receiving Ⓝ
     * @param amount Amount to send in yoctoⓃ
     */
  }, {
    key: "sendMoney",
    value: function sendMoney(receiverId, amount) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.signAndSendTransaction({
                receiverId: receiverId,
                actions: [(0, transaction_1.transfer)(amount)]
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
    /**
     * @param newAccountId NEAR account name to be created
     * @param publicKey A public key created from the masterAccount
     */
  }, {
    key: "createAccount",
    value: function createAccount(newAccountId, publicKey, amount) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var accessKey;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              accessKey = (0, transaction_1.fullAccessKey)();
              return _context8.abrupt("return", this.signAndSendTransaction({
                receiverId: newAccountId,
                actions: [(0, transaction_1.createAccount)(), (0, transaction_1.transfer)(amount), (0, transaction_1.addKey)(key_pair_1.PublicKey.from(publicKey), accessKey)]
              }));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
    /**
     * @param beneficiaryId The NEAR account that will receive the remaining Ⓝ balance from the account being deleted
     */
  }, {
    key: "deleteAccount",
    value: function deleteAccount(beneficiaryId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!process.env['NEAR_NO_LOGS']) {
                console.log('Deleting an account does not automatically transfer NFTs and FTs to the beneficiary address. Ensure to transfer assets before deleting.');
              }
              return _context9.abrupt("return", this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [(0, transaction_1.deleteAccount)(beneficiaryId)]
              }));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
    /**
     * @param data The compiled contract code
     */
  }, {
    key: "deployContract",
    value: function deployContract(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [(0, transaction_1.deployContract)(data)]
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
    /** @hidden */
  }, {
    key: "encodeJSContractArgs",
    value: function encodeJSContractArgs(contractId, method, args) {
      return Buffer.concat([Buffer.from(contractId), Buffer.from([0]), Buffer.from(method), Buffer.from([0]), Buffer.from(args)]);
    }
    /**
     * Execute function call
     * @returns {Promise<FinalExecutionOutcome>}
     */
  }, {
    key: "functionCall",
    value: function functionCall(_ref2) {
      var contractId = _ref2.contractId,
        methodName = _ref2.methodName,
        _ref2$args = _ref2.args,
        args = _ref2$args === void 0 ? {} : _ref2$args,
        _ref2$gas = _ref2.gas,
        gas = _ref2$gas === void 0 ? constants_1.DEFAULT_FUNCTION_CALL_GAS : _ref2$gas,
        attachedDeposit = _ref2.attachedDeposit,
        walletMeta = _ref2.walletMeta,
        walletCallbackUrl = _ref2.walletCallbackUrl,
        stringify = _ref2.stringify,
        jsContract = _ref2.jsContract;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var functionCallArgs, encodedArgs, stringifyArg;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.validateArgs(args);
              if (jsContract) {
                encodedArgs = this.encodeJSContractArgs(contractId, methodName, JSON.stringify(args));
                functionCallArgs = ['call_js_contract', encodedArgs, gas, attachedDeposit, null, true];
              } else {
                stringifyArg = stringify === undefined ? transaction_1.stringifyJsonOrBytes : stringify;
                functionCallArgs = [methodName, args, gas, attachedDeposit, stringifyArg, false];
              }
              return _context11.abrupt("return", this.signAndSendTransaction({
                receiverId: jsContract ? this.connection.jsvmAccountId : contractId,
                // eslint-disable-next-line prefer-spread
                actions: [transaction_1.functionCall.apply(void 0, functionCallArgs)],
                walletMeta: walletMeta,
                walletCallbackUrl: walletCallbackUrl
              }));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
    /**
     * @see [https://docs.near.org/concepts/basics/accounts/access-keys](https://docs.near.org/concepts/basics/accounts/access-keys)
     * @todo expand this API to support more options.
     * @param publicKey A public key to be associated with the contract
     * @param contractId NEAR account where the contract is deployed
     * @param methodNames The method names on the contract that should be allowed to be called. Pass null for no method names and '' or [] for any method names.
     * @param amount Payment in yoctoⓃ that is sent to the contract during this function call
     */
  }, {
    key: "addKey",
    value: function addKey(publicKey, contractId, methodNames, amount) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var accessKey;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!methodNames) {
                methodNames = [];
              }
              if (!Array.isArray(methodNames)) {
                methodNames = [methodNames];
              }
              if (!contractId) {
                accessKey = (0, transaction_1.fullAccessKey)();
              } else {
                accessKey = (0, transaction_1.functionCallAccessKey)(contractId, methodNames, amount);
              }
              return _context12.abrupt("return", this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [(0, transaction_1.addKey)(key_pair_1.PublicKey.from(publicKey), accessKey)]
              }));
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
    /**
     * @param publicKey The public key to be deleted
     * @returns {Promise<FinalExecutionOutcome>}
     */
  }, {
    key: "deleteKey",
    value: function deleteKey(publicKey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [(0, transaction_1.deleteKey)(key_pair_1.PublicKey.from(publicKey))]
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
    /**
     * @see [https://near-nodes.io/validator/staking-and-delegation](https://near-nodes.io/validator/staking-and-delegation)
     *
     * @param publicKey The public key for the account that's staking
     * @param amount The account to stake in yoctoⓃ
     */
  }, {
    key: "stake",
    value: function stake(publicKey, amount) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [(0, transaction_1.stake)(amount, key_pair_1.PublicKey.from(publicKey))]
              }));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
    /** @hidden */
  }, {
    key: "validateArgs",
    value: function validateArgs(args) {
      var isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
      if (isUint8Array) {
        return;
      }
      if (Array.isArray(args) || typeof args !== 'object') {
        throw new errors_1.PositionalArgsError();
      }
    }
    /**
     * Invoke a contract view function using the RPC API.
     * @see [https://docs.near.org/api/rpc/contracts#call-a-contract-function](https://docs.near.org/api/rpc/contracts#call-a-contract-function)
     *
     * @param contractId NEAR account where the contract is deployed
     * @param methodName The view-only method (no state mutations) name on the contract as it is written in the contract code
     * @param args Any arguments to the view contract method, wrapped in JSON
     * @param options.parse Parse the result of the call. Receives a Buffer (bytes array) and converts it to any object. By default result will be treated as json.
     * @param options.stringify Convert input arguments into a bytes array. By default the input is treated as a JSON.
     * @param options.jsContract Is contract from JS SDK, automatically encodes args from JS SDK to binary.
     * @param options.blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     * @returns {Promise<any>}
     */
  }, {
    key: "viewFunction",
    value: function viewFunction() {
      for (var _len = arguments.length, restArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        restArgs[_key] = arguments[_key];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var contractId, methodName, args, options;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!(typeof restArgs[0] === 'string')) {
                _context15.next = 10;
                break;
              }
              contractId = restArgs[0];
              methodName = restArgs[1];
              args = restArgs[2];
              options = restArgs[3];
              _context15.next = 7;
              return this.viewFunctionV1(contractId, methodName, args, options);
            case 7:
              return _context15.abrupt("return", _context15.sent);
            case 10:
              _context15.next = 12;
              return this.viewFunctionV2(restArgs[0]);
            case 12:
              return _context15.abrupt("return", _context15.sent);
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "viewFunctionV1",
    value: function viewFunctionV1(contractId, methodName) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref3$parse = _ref3.parse,
        parse = _ref3$parse === void 0 ? parseJsonFromRawResponse : _ref3$parse,
        _ref3$stringify = _ref3.stringify,
        stringify = _ref3$stringify === void 0 ? bytesJsonStringify : _ref3$stringify,
        _ref3$jsContract = _ref3.jsContract,
        jsContract = _ref3$jsContract === void 0 ? false : _ref3$jsContract,
        _ref3$blockQuery = _ref3.blockQuery,
        blockQuery = _ref3$blockQuery === void 0 ? {
          finality: 'optimistic'
        } : _ref3$blockQuery;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var deprecate;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              deprecate = (0, depd_1.default)('Account.viewFunction(contractId, methodName, args, options)');
              deprecate('use `Account.viewFunction(ViewFunctionCallOptions)` instead');
              return _context16.abrupt("return", this.viewFunctionV2({
                contractId: contractId,
                methodName: methodName,
                args: args,
                parse: parse,
                stringify: stringify,
                jsContract: jsContract,
                blockQuery: blockQuery
              }));
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "viewFunctionV2",
    value: function viewFunctionV2(_ref4) {
      var contractId = _ref4.contractId,
        methodName = _ref4.methodName,
        args = _ref4.args,
        _ref4$parse = _ref4.parse,
        parse = _ref4$parse === void 0 ? parseJsonFromRawResponse : _ref4$parse,
        _ref4$stringify = _ref4.stringify,
        stringify = _ref4$stringify === void 0 ? bytesJsonStringify : _ref4$stringify,
        _ref4$jsContract = _ref4.jsContract,
        jsContract = _ref4$jsContract === void 0 ? false : _ref4$jsContract,
        _ref4$blockQuery = _ref4.blockQuery,
        blockQuery = _ref4$blockQuery === void 0 ? {
          finality: 'optimistic'
        } : _ref4$blockQuery;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var encodedArgs, result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              this.validateArgs(args);
              if (jsContract) {
                encodedArgs = this.encodeJSContractArgs(contractId, methodName, Object.keys(args).length > 0 ? JSON.stringify(args) : '');
              } else {
                encodedArgs = stringify(args);
              }
              _context17.next = 4;
              return this.connection.provider.query(Object.assign(Object.assign({
                request_type: 'call_function'
              }, blockQuery), {
                account_id: jsContract ? this.connection.jsvmAccountId : contractId,
                method_name: jsContract ? 'view_js_contract' : methodName,
                args_base64: encodedArgs.toString('base64')
              }));
            case 4:
              result = _context17.sent;
              if (result.logs) {
                this.printLogs(contractId, result.logs);
              }
              return _context17.abrupt("return", result.result && result.result.length > 0 && parse(Buffer.from(result.result)));
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
    /**
     * Returns the state (key value pairs) of this account's contract based on the key prefix.
     * Pass an empty string for prefix if you would like to return the entire state.
     * @see [https://docs.near.org/api/rpc/contracts#view-contract-state](https://docs.near.org/api/rpc/contracts#view-contract-state)
     *
     * @param prefix allows to filter which keys should be returned. Empty prefix means all keys. String prefix is utf-8 encoded.
     * @param blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     */
  }, {
    key: "viewState",
    value: function viewState(prefix) {
      var blockQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        finality: 'optimistic'
      };
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _yield$this$connectio, values;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.connection.provider.query(Object.assign(Object.assign({
                request_type: 'view_state'
              }, blockQuery), {
                account_id: this.accountId,
                prefix_base64: Buffer.from(prefix).toString('base64')
              }));
            case 2:
              _yield$this$connectio = _context18.sent;
              values = _yield$this$connectio.values;
              return _context18.abrupt("return", values.map(function (_ref5) {
                var key = _ref5.key,
                  value = _ref5.value;
                return {
                  key: Buffer.from(key, 'base64'),
                  value: Buffer.from(value, 'base64')
                };
              }));
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
    /**
     * Get all access keys for the account
     * @see [https://docs.near.org/api/rpc/access-keys#view-access-key-list](https://docs.near.org/api/rpc/access-keys#view-access-key-list)
     */
  }, {
    key: "getAccessKeys",
    value: function getAccessKeys() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var response;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.connection.provider.query({
                request_type: 'view_access_key_list',
                account_id: this.accountId,
                finality: 'optimistic'
              });
            case 2:
              response = _context19.sent;
              return _context19.abrupt("return", (_a = response === null || response === void 0 ? void 0 : response.keys) === null || _a === void 0 ? void 0 : _a.map(function (key) {
                return Object.assign(Object.assign({}, key), {
                  access_key: Object.assign(Object.assign({}, key.access_key), {
                    nonce: new bn_js_1.default(key.access_key.nonce)
                  })
                });
              }));
            case 4:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
    /**
     * Returns a list of authorized apps
     * @todo update the response value to return all the different keys, not just app keys.
     */
  }, {
    key: "getAccountDetails",
    value: function getAccountDetails() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var accessKeys, authorizedApps;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.getAccessKeys();
            case 2:
              accessKeys = _context20.sent;
              authorizedApps = accessKeys.filter(function (item) {
                return item.access_key.permission !== 'FullAccess';
              }).map(function (item) {
                var perm = item.access_key.permission;
                return {
                  contractId: perm.FunctionCall.receiver_id,
                  amount: perm.FunctionCall.allowance,
                  publicKey: item.public_key
                };
              });
              return _context20.abrupt("return", {
                authorizedApps: authorizedApps
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
    /**
     * Returns calculated account balance
     */
  }, {
    key: "getAccountBalance",
    value: function getAccountBalance() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var protocolConfig, state, costPerByte, stateStaked, staked, totalBalance, availableBalance;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.connection.provider.experimental_protocolConfig({
                finality: 'final'
              });
            case 2:
              protocolConfig = _context21.sent;
              _context21.next = 5;
              return this.state();
            case 5:
              state = _context21.sent;
              costPerByte = new bn_js_1.default(protocolConfig.runtime_config.storage_amount_per_byte);
              stateStaked = new bn_js_1.default(state.storage_usage).mul(costPerByte);
              staked = new bn_js_1.default(state.locked);
              totalBalance = new bn_js_1.default(state.amount).add(staked);
              availableBalance = totalBalance.sub(bn_js_1.default.max(staked, stateStaked));
              return _context21.abrupt("return", {
                total: totalBalance.toString(),
                stateStaked: stateStaked.toString(),
                staked: staked.toString(),
                available: availableBalance.toString()
              });
            case 12:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
    }
    /**
     * Returns the NEAR tokens balance and validators of a given account that is delegated to the staking pools that are part of the validators set in the current epoch.
     *
     * NOTE: If the tokens are delegated to a staking pool that is currently on pause or does not have enough tokens to participate in validation, they won't be accounted for.
     * @returns {Promise<ActiveDelegatedStakeBalance>}
     */
  }, {
    key: "getActiveDelegatedStakeBalance",
    value: function getActiveDelegatedStakeBalance() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var _this2 = this;
        var block, blockHash, epochId, _yield$this$connectio2, current_validators, next_validators, current_proposals, pools, uniquePools, promises, results, hasTimeoutError, summary;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return this.connection.provider.block({
                finality: 'final'
              });
            case 2:
              block = _context22.sent;
              blockHash = block.header.hash;
              epochId = block.header.epoch_id;
              _context22.next = 7;
              return this.connection.provider.validators(epochId);
            case 7:
              _yield$this$connectio2 = _context22.sent;
              current_validators = _yield$this$connectio2.current_validators;
              next_validators = _yield$this$connectio2.next_validators;
              current_proposals = _yield$this$connectio2.current_proposals;
              pools = new Set();
              [].concat(_toConsumableArray(current_validators), _toConsumableArray(next_validators), _toConsumableArray(current_proposals)).forEach(function (validator) {
                return pools.add(validator.account_id);
              });
              uniquePools = _toConsumableArray(pools);
              promises = uniquePools.map(function (validator) {
                return _this2.viewFunction({
                  contractId: validator,
                  methodName: 'get_account_total_balance',
                  args: {
                    account_id: _this2.accountId
                  },
                  blockQuery: {
                    blockId: blockHash
                  }
                });
              });
              _context22.next = 17;
              return Promise.allSettled(promises);
            case 17:
              results = _context22.sent;
              hasTimeoutError = results.some(function (result) {
                if (result.status === 'rejected' && result.reason.type === 'TimeoutError') {
                  return true;
                }
                return false;
              }); // When RPC is down and return timeout error, throw error
              if (!hasTimeoutError) {
                _context22.next = 21;
                break;
              }
              throw new Error('Failed to get delegated stake balance');
            case 21:
              summary = results.reduce(function (result, state, index) {
                var validatorId = uniquePools[index];
                if (state.status === 'fulfilled') {
                  var currentBN = new bn_js_1.default(state.value);
                  if (!currentBN.isZero()) {
                    return Object.assign(Object.assign({}, result), {
                      stakedValidators: [].concat(_toConsumableArray(result.stakedValidators), [{
                        validatorId: validatorId,
                        amount: currentBN.toString()
                      }]),
                      total: result.total.add(currentBN)
                    });
                  }
                }
                if (state.status === 'rejected') {
                  return Object.assign(Object.assign({}, result), {
                    failedValidators: [].concat(_toConsumableArray(result.failedValidators), [{
                      validatorId: validatorId,
                      error: state.reason
                    }])
                  });
                }
                return result;
              }, {
                stakedValidators: [],
                failedValidators: [],
                total: new bn_js_1.default(0)
              });
              return _context22.abrupt("return", Object.assign(Object.assign({}, summary), {
                total: summary.total.toString()
              }));
            case 23:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
    }
  }]);
  return Account;
}();
exports.Account = Account;